<template>
    <div class="job-description">
        <div class="container-fluid">
            <Navbar />
                <div class="content py-4 mt-5">
                    <div class="jobdetails m-auto">
                        <h3 class="text-left mt-5 ml-4">Job Details</h3>
                        <div class="row bg-white shadow">
                            <div class="col-sm-12 col-md-12 p-0 m-0 col-lg-8 border border-right-0">
                                <div class="project-title py-4 bg-light w-100 border border-right-0 border-left-0">
                                    <h4 class="text-left ml-4 font-weight-bold">
                                        Front end Developers needed for modifying existing applications
                                    </h4>
                                </div>
                                <div class="project-body p-4">
                                    <div class="specialization">
                                        <h5 class="kova-text font-weight-bold text-left"> Web Development </h5>
                                        <p class="lighten-text incr-size1 text-left"> Posted ** hours ago </p>
                                    </div>
                                    <hr />
                                    <div class="description text-left">
                                        <p>I have an existing front-end application written in simple HTML, CSS, JS and jQery. No fancy framework.
                                            This calls back-end API and presents some pages.
                                        </p>
                                        <p> I need the following enhancement here </p>
                                        <ol>
                                            <li>The page has videojs integrated for playng HLS. I need some modifications here to add
                                            multiple players.
                                            </li>
                                            <li>A new page to be created which will call back-end API and build the HTML.</li>
                                        </ol>
                                    </div>
                                    <hr />
                                    <div class="price-and-level">
                                        <div class="row">
                                            <div class="col-md-5">
                                                <h6 class="font-weight-bolder text-left mt-3">$15/hr</h6>
                                                <p class="font-weight-lighter lighten-text text-left">Hourly</p>
                                            </div>
                                            <div class="col-md-5">
                                                <h6 class="font-weight-bolder text-left mt-3">Intemediate</h6>
                                                <p class="font-weight-lighter lighten-text text-left">Skill Level</p>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="project-type text-left">
                                        <p><b>Project Type:</b> One Time Project</p>
                                    </div>
                                    <hr />
                                    <div class="skills text-left">
                                        <h5 class="kova-text font-weight-bold">Skills required</h5>
                                        <div class="px-4">
                                            <div class="text-left d-flex flex-wrap">
                                            <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">HTML</span>
                                            <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">CSS</span>
                                            <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">JavaScript</span>
                                            <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">React.js</span>
                                            <span class="bg-skills px-3 py-2 ml-3 mt-3 rounded">Web application development</span>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="activities text-left">
                                        <h5 class="kova-text font-weight-bold">Activities on this Job</h5>
                                        <p class="lighten-text font-weight-bold incr-size1 text-left"> Proposal: **</p>
                                        <p class="lighten-text font-weight-bold incr-size1 text-left"> Last Viewed by Client: **</p>
                                        <p class="lighten-text font-weight-bold incr-size1 text-left"> Interviewing: **</p>
                                        <p class="lighten-text font-weight-bold incr-size1 text-left"> Invites Sent: **</p>
                                        <p class="lighten-text font-weight-bold incr-size1 text-left"> Unanswered Invite: **</p>

                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-4 px-4 border">
                                <div class="row my-3 pb-3">
                                    <div class="col-sm-12 col-md-6 col-lg-12">
                                        <button class="btn btn-kovatek w-100 mt-3">Bid on Project</button>
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-12">
                                        <button class="btn btn-kovatek-outline w-100 mt-3">Save Job</button>
                                    </div>
                                </div>
                                    <p class="lighten-text font-weight-bold incr-size1 text-left mt-4"> Required Connects to submit a proposal: **</p>
                                    <p class="lighten-text font-weight-bold incr-size1 text-left m-0 p-0"> Available Connect: **</p>
                                <hr />
                                    <h5 class="kova-text font-weight-bold text-left">About Client</h5>
                                    <div>
                                        <h6 class="font-weight-bolder text-left mt-3">Payment Method</h6>
                                        <p class="font-weight-lighter lighten-text text-left">** reviews</p>
                                    </div>
                                    <div>
                                        <h6 class="font-weight-bolder text-left mt-3">Country</h6>
                                        <p class="font-weight-lighter lighten-text text-left">***</p>
                                    </div>
                                    <div>
                                        <h6 class="font-weight-bolder text-left mt-3">Total job posted</h6>
                                        <p class="font-weight-lighter lighten-text text-left">***</p>
                                    </div>
                                    <div>
                                        <h6 class="font-weight-bolder text-left mt-3">Total amount spent</h6>
                                        <p class="font-weight-lighter lighten-text text-left">***</p>
                                    </div>
                                        <p class="font-weight-bolder lighten-text text-left">Member since Oct 20, 2019</p>
                            </div>
                        </div>
                    </div>
                    <div class="project-bids border mx-auto mt-5">
                        <div class="project-title py-4 bg-light w-100 border border-top-0">
                            <h4 class="text-left ml-4 font-weight-bold">
                                Bidders
                            </h4>
                        </div>
                        <div class="bidders p-4">
                            <div class="bid" :key="bid" v-for="bid in bidders">
                                <div class="row">
                                    <div class="col-2 p-2">
                                        <img :src="require(`@/assets/KOVATEK/IMAGES/${bid.image}`)" class="bidder-img" alt="bidder"/>
                                    </div>
                                    <div class="col-10 text-left">
                                        <h6 class="font-weight-bold">{{bid.name}}</h6>
                                        <span :key="n" v-for="n in bid.star"><font-awesome-icon icon="star" size=""></font-awesome-icon></span> <b>{{bid.star}}.00</b> ({{bid.reviews}} reviews)
                                         
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-2 p-2">
                                    </div>
                                    <div class="col-6 text-left">
                                         <h6 class="font-weight-bold">{{bid.moneyMade}}</h6> 
                                    </div>
                                    <div class="col-4 text-right">
                                        <p class="lighten-text"> {{bid.whenBidPlaced }}</p>
                                    </div>
                                </div>
                                <hr />
                            </div>
                            <button class="btn btn-kovatek w-100 mt-3">See more</button>
                        </div>
                    </div>
                    <div class="client-history border mx-auto mt-5">
                        <div class="project-title py-4 bg-light w-100 border border-top-0">
                            <h4 class="text-left ml-4 font-weight-bold">
                                Client's Recent History ({{histories.length}})
                            </h4>
                        </div>
                        <div class="history p-4">
                            <div class="row" :key="history" v-for="history in histories">
                                <div class="col-sm-12 col-md-9 text-left">
                                    <h6 class="kova-text font-weight-bold">{{history.projectName}}</h6>
                                    <p class="incr-size1">{{history.status}}</p>
                                    <p>Freelancer: <span class="font-weight-bold kova-text">{{history.freelancerName}}</span></p>
                                </div>
                                <div class="col-sm-12 col-md-3 text-left">
                                    <p class="incr-size1">{{history.projectStarted}} {{(history.status == "Job in progress")? "- present":""}}</p>
                                </div>
                                <hr />
                            </div>
                        </div>
                    </div>
                </div>
            <Footer />
        </div>
    </div>
</template>

<script>

import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';

export default {
    name: 'job-description',
    components: {
        Navbar, Footer
    },
    data(){
        return{
            bidders: [{
                name:"Mike. P", image:"mike.png", star:5, reviews:300, whenBidPlaced: "2 days ago", moneyMade: "$250 in 3 days"
            },
            {
                name:"Johnson. K", image:"developer-1.png", star:5, reviews:175, whenBidPlaced: "2 days ago", moneyMade: "$175 in 5 days"
            },
            {
                name:"Adara. W", image:"developer-2.jpeg", star:4, reviews:120, whenBidPlaced: "3 days ago", moneyMade: "$150 in 4 days"
            },
            {
                name:"Idris .A", image:"developer-3.png", star:5, reviews:85, whenBidPlaced: "2 days ago", moneyMade: "$300 in 7 days"
            }],
            histories: [{
                projectName: "Programmer ReactJS + Redux", status:"Job in progress", freelancerName:"Mike. P", projectStarted:"Jan 2020"
            },
            {
                projectName: "Front-end Angular Engineer needed for 3 month project", status:"Job in progress", freelancerName:"Idris. A", projectStarted:"Dec 2019"
            }]
        }
    }
}
</script>

<style scoped>
.jobdetails{
    width: 75%;
}
.kova-text{
  color:#20409a;
}
.lighten-text{
  color: #777
}
.incr-size1{
    font-size: 16px;
}
.incr-size2{
    font-size: 18px;
}
.incr-size3{
    font-size: 20px;
}
.incr-size4{
    font-size: 22px;
}
.bg-skills{
  background-color: #dde;
  transition: 0.1s;
}
.bg-skills:hover{
  background-color: #20409a;
  color: #fff;
}
.btn-kovatek{
  background-color: #20409A;
  height: 50px;
  color: #fff;
  transition: 0.1s;
  box-shadow: 0 0 10px rgba(0,0,0, 0.3);

}
.btn-kovatek:hover{
  background-color: #06216d;
  box-shadow: 0 0 15px rgba(0,0,0, 0.6);
  color: #fff;
}
.btn-kovatek-outline{
  background-color: #fff;
  height: 50px;
  color: #20409A;
  box-shadow: 0 0 10px rgba(0,0,0, 0.3);
  transition: 0.1s;
}
.btn-kovatek-outline:hover{
  color: #20409A;
  box-shadow: 0 0 15px rgba(0,0,0, 0.6);
}
.project-bids{
    width: 60%;
}
.bidder-img{
    width: 50px;
    height:50px;
    border-radius: 10px;
}
.client-history{
    width: 60%;
}

@media screen and (min-width: 1110px) and (max-width: 1325px){
    .jobdetails{
        width: 85%;
    }
    .project-bids{
        width: 65%;
    }
    .client-history{
        width: 70%;
    }
}

@media screen and (min-width: 992px) and (max-width: 1111px){
    .jobdetails{
        width: 90%;
    }
    .project-bids{
        width: 80%;
    }
    .client-history{
        width: 80%;
    }
}
@media screen and (min-width: 768px) and (max-width: 991px){
  .jobdetails{
        width: 94%;
    }
    .project-bids{
        width: 94%;
    }
    .client-history{
        width: 94%;
    }
}
@media screen and (max-width: 767px){
.jobdetails{
    width: 100%;
}
.project-bids{
    width: 100%;
}
.client-history{
    width: 100%;
}

}
</style>